// ✅ Better type inference and narrowing with const assertion
export const CRUD_ACTIONS = ['create', 'read', 'update', 'delete'] as const;
export const CASL_ACTIONS = ['manage' /* Special CASL keyword: represents any action */] as const;
// export type Action = Exclude<(typeof actions)[number], 'manage'>;
